import { ApplicationStore } from '@data';

export default function merge(
  persistedState: unknown,
  initialState: ApplicationStore,
) {
  const persisted = persistedState as ApplicationStore | undefined;
  return {
    ...initialState,
    auth: {
      ...initialState.auth,
      ...persisted?.auth,
    },
    patient: {
      ...initialState.patient,
      ...persisted?.patient,
    },
    reservedVisit: persisted?.reservedVisit || undefined,
    visit: persisted?.visit || null,
    visitTypeId: persisted?.visitTypeId || null,
    stateCode: persisted?.stateCode || undefined,
    devTools: { ...initialState.devTools, ...persisted?.devTools },
    intakeQuiz: {
      ...initialState.intakeQuiz,
      ...persisted?.intakeQuiz,
    },
  };
}
